import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { PHONE, TEL, EMAIL, TAGLINE, AREAS_TEXT } from "@/data/site";

const LINKS = [
  ["/", "Home"], ["/about", "About"], ["/home-watch-services", "Home Watch"], ["/concierge-services", "Concierge"],
  ["/plans-and-pricing", "Home Watch Plans"], ["/service-areas", "Service Areas"], ["/hurricane-season-home-watch", "Hurricane Season"], ["/contact", "Contact"],
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[#0e1b2c] pb-28 pt-20 text-white md:pb-12">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-sm font-display text-2xl italic leading-snug text-white/90">{TAGLINE}</p>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-white/70">Locally Owned | Veteran-Owned | Firefighter-Founded | Western Palm Beach County</p>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#e9a3a8]">Contact</p>
          <a href={TEL} data-testid="footer-phone-link" className="mt-4 flex items-center gap-3 font-display text-3xl hover:text-[#e9a3a8]">
            <Phone className="h-5 w-5" /> {PHONE}
          </a>
          <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="mt-3 flex items-center gap-3 break-all text-sm text-white/85 hover:text-white"><Mail className="h-4 w-4 shrink-0" /> {EMAIL}</a>
          <p data-testid="footer-location" className="mt-3 flex items-center gap-3 text-sm text-white/80"><MapPin className="h-4 w-4 shrink-0" /> Based in Wellington, FL 33414 | Serving Western Palm Beach County</p>
          <p className="mt-4 text-sm leading-relaxed text-white/80">Serving {AREAS_TEXT}.</p>
        </div>
        <nav className="lg:col-span-4" aria-label="Footer">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#e9a3a8]">Explore</p>
          <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
            {LINKS.map(([to, l]) => (
              <li key={to}><Link to={to} data-testid={`footer-link-${l.toLowerCase().replace(/\s/g, "-")}`} className="link-underline pb-0.5 text-white/85 hover:text-white">{l}</Link></li>
            ))}
            <li><Link to="/privacy" data-testid="footer-link-privacy" className="link-underline pb-0.5 text-white/85 hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-link-terms" className="link-underline pb-0.5 text-white/85 hover:text-white">Terms of Use</Link></li>
          </ul>
        </nav>
      </div>
      <div className="mt-16 select-none font-display text-[18vw] font-bold leading-[0.8] tracking-tight text-white/[0.05] lg:text-[13rem]" aria-hidden="true">FIRST DUE</div>
      <div className="mt-6 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-white/70 md:flex-row md:justify-between">
        <p>© 2026 First Due Home Watch &amp; Concierge. All rights reserved.</p>
        <p data-testid="footer-disclaimer">Independent, privately owned business. Not affiliated with or endorsed by Palm Beach County Fire Rescue or the United States Army.</p>
      </div>
    </div>
  </footer>
);

export const MobileCallBar = () => (
  <div data-testid="mobile-call-bar" className="fixed inset-x-0 bottom-0 z-50 flex gap-2 border-t border-white/10 bg-[#14263D]/95 p-3 backdrop-blur-md md:hidden">
    <a href={TEL} data-testid="mobile-sticky-call-btn" className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#A52A32] py-3 text-sm font-semibold text-white">
      <Phone className="h-4 w-4" /> Call Now {PHONE}
    </a>
    <Link to="/contact" data-testid="mobile-sticky-consult-btn" className="flex items-center justify-center rounded-full border border-white/40 px-4 text-sm font-semibold text-white">
      Free Consult
    </Link>
  </div>
);
